import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from 'vue-router'
import Axios from 'axios'
import qs from 'qs'
import CryptoJS from 'crypto-js'
import routes from './router'
import sensors from "./store/utils/sensors";

Vue.use(VueRouter)
Vue.use(ElementUI)

Vue.use(Axios)
Vue.use(qs)
Vue.use(CryptoJS)

Vue.config.productionTip = false
Vue.prototype.$sensors = sensors;

/** 兼容开发环境 */
let base = '/'

const router = new VueRouter({
  mode: 'hash',
  base,
  routes,
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

//加密

//加密

Vue.prototype.encryption = function(params) {
  var keyStr = "l5TJHfZrmY38Hf2e2H1h0Q==";
  var key = CryptoJS.enc.Utf8.parse(keyStr);
  var srcs = CryptoJS.enc.Utf8.parse(params);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });

  return encrypted.toString();
};

//解密
Vue.prototype.decryption = function(params) {
  var keyStr = "l5TJHfZrmY38Hf2e2H1h0Q==";
  var key = CryptoJS.enc.Utf8.parse(keyStr);
  var decrypt = CryptoJS.AES.decrypt(params, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
};